import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=455e6722&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455e6722",
  null
  
)

export default component.exports